import config from "../../../../config";
import { ResponseDto } from '../../../../dtos/common/responseDto';
import { deleteData, getData, patchData, postData } from '../../../../utils/axios/serverHelper';
import { formatDate } from '../../../../utils/string/stringUtil';
import axios from 'axios';

import { PUR2010_R01DetailDto, PUR2010_R01Dto, PUR2010_R01HeaderDto } from './Dto_PUR2010_R01';
import { PUR2010_R01Filter } from "./Store_PUR2010_R01";

const baseUrl = `${config.apiUrl}/PUR2010_R01`;

const getParams = (filter: Partial<PUR2010_R01Filter>, listLength?: number) => {	
	return {
		startDate: filter.dateRange?.from ? formatDate(filter.dateRange.from) : undefined,
		endDate: filter.dateRange?.to ? formatDate(filter.dateRange.to) : undefined,
		customCd: filter.customCd || undefined,	

		listLength: listLength || 0
	}
}

export const getPUR2010_R01List = async (option: string, params: Partial<PUR2010_R01Filter>, listLength: number = 0) => {

	const url = `${baseUrl}/${option}`;

	return await getData<ResponseDto<PUR2010_R01HeaderDto[]>>(url, { params: getParams(params, listLength) });
}

export const getPUR2010_R01AllCount = async (params: Partial<PUR2010_R01Filter>) => {
    const url = `${baseUrl}/allCount`;

    return await getData<ResponseDto<number>>(url, {
        params: getParams(params, 0)
    });
}

export const getPUR2010_R01One = async (purchaseBillNo: string) => {
	const url = `${baseUrl}/one/${purchaseBillNo}`;
	return await getData<ResponseDto<PUR2010_R01HeaderDto>>(url);
}

export const getPUR2010_R01DetailList = async (purchaseBillNo: string) => {
	const url = `${baseUrl}/detail/${purchaseBillNo}`;

	return await getData<ResponseDto<PUR2010_R01DetailDto[]>>(url);
}

export const postPUR2010_R01 = async (data: PUR2010_R01Dto) => {

	const url = `${baseUrl}`;

	return await postData<PUR2010_R01Dto, ResponseDto<PUR2010_R01Dto[]>>(url, data);
}

export const patchPUR2010_R01 = async (data: PUR2010_R01Dto) => {

	const url = `${baseUrl}`;

	return await patchData<PUR2010_R01Dto, ResponseDto<PUR2010_R01Dto[]>>(url, data);
}

export const deletePUR2010_R01 = async (purchaseBillNo: string) => {

	const url = `${baseUrl}`;

	return await deleteData<ResponseDto<any>>(url, {
		params: {
			purchaseBillNo
		}
	});
}

export const downloadExcel_PUR2010_R01 = async (option: string, purchaseBillNo: string, listLength: number = 0) => {
	const url = `${baseUrl}/excel/${option}`

	return await getData<ResponseDto<string>>(url, {
		params: {
			purchaseBillNo
		}
	})
}
/** 매입전표 PDF Blob 반환 (출력은 Content에서 QZ/브라우저 폴백 처리) */
export const getPdfBlob_PUR2010_R01 = async (purchaseBillNo: string): Promise<Blob> => {
	const url = `${baseUrl}/print`;
	const response = await getData<Blob>(url, {
		params: { purchaseBillNo },
		responseType: "blob",
	});
	return new Blob([response.data], { type: "application/pdf" });
};